var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4176_18561",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 28,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 5.00521C6.66406 3.16426 8.15645 1.67188 9.9974 1.67188H21.95C22.8341 1.67188 23.6819 2.02306 24.307 2.64819L32.3544 10.6956C32.9795 11.3207 33.3307 12.1685 33.3307 13.0526V35.0052C33.3307 36.8462 31.8383 38.3385 29.9974 38.3385H9.99739C8.15644 38.3385 6.66406 36.8462 6.66406 35.0052V5.00521Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4176_18561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 5.00521C6.66406 3.16426 8.15645 1.67188 9.9974 1.67188H29.9974C31.8383 1.67188 33.3307 3.16426 33.3307 5.00521V35.0052C33.3307 36.8462 31.8383 38.3385 29.9974 38.3385H9.99739C8.15644 38.3385 6.66406 36.8462 6.66406 35.0052V5.00521Z",
    fill: "#7E74FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3359 20.2031L24.7585 11.6257C24.2336 11.1007 24.6054 10.2031 25.3478 10.2031H33.3359V20.2031Z",
    fill: "url(#paint0_linear_4176_18561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3359 1.67188L33.3359 11.6719H26.6693C24.8283 11.6719 23.3359 10.1795 23.3359 8.33854V1.67188Z",
    fill: "#B8B3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1641 21.6719C25.5448 21.6719 26.6641 20.5526 26.6641 19.1719C26.6641 17.7912 25.5448 16.6719 24.1641 16.6719C22.7834 16.6719 21.6641 17.7912 21.6641 19.1719C21.6641 20.5526 22.7834 21.6719 24.1641 21.6719Z",
    fill: "#D9D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.277 30.8374L25.6744 26.7202C24.8776 25.8095 23.4609 25.8095 22.6641 26.7202L19.0615 30.8374C18.7787 31.1607 19.0082 31.6667 19.4378 31.6667H28.9007C29.3303 31.6667 29.5599 31.1607 29.277 30.8374Z",
    fill: "#D9D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2997 30.848L19.1216 23.5796C18.2907 22.6021 16.7674 22.6486 15.9977 23.6749L10.6 30.8719C10.3528 31.2015 10.588 31.6719 11 31.6719H24.9188C25.345 31.6719 25.5758 31.1728 25.2997 30.848Z",
    fill: "#D9D6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4176_18561",
    x1: 28.3359,
    y1: 20.2031,
    x2: 28.3359,
    y2: 9.99479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E74FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584CF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.3b514001e144778b1b2e0c9c050d5c20.svg";
export { ForwardRef as ReactComponent };